import * as Sentry from "@sentry/browser";
import { getCurrentUser, fetchUserAttributes } from "aws-amplify/auth";
import axios, { AxiosError } from "axios";

const handleApiError = async (error: Error | AxiosError | unknown, extras?: Record<string, unknown>) => {
  let errorToReport: Error | undefined;
  let errorInfo: Record<string, unknown> | undefined;

  // ignore canceled requests
  if (axios.isCancel(error)) return;

  if (axios.isAxiosError(error)) {
    // ignore when we are disconnected
    if (error.message === "Network Error") {
      return;
    }

    errorToReport = new Error(
      `${error.response?.status ?? "unknown"}, ${error.response?.statusText ?? "unknown"}, ${error.config?.url ?? "unknown"}`,
    );
    errorToReport.name = "API Error";
    errorInfo = {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      body: error.response?.data,
    };
  } else if (error instanceof Error) {
    if ("noAuth" in error) {
      window.location.href = `${import.meta.env.BASE_URL}#/welcome`;
      return;
    }
    errorToReport = error;
  }
  if (extras) {
    errorInfo = { ...errorInfo, ...extras };
  }
  if (errorToReport) {
    Sentry.withScope(async (scope) => {
      try {
        const user = await getCurrentUser();
        if (!user) {
          throw new Error("User not found");
        }
        const userAttributes = await fetchUserAttributes();
        scope.setUser({
          email: userAttributes.email,
          id: userAttributes.sub,
          username: user.username,
        });
      } catch (err) {
        if (errorInfo) {
          errorInfo.authError = `Auth.currentAuthenticatedUser failed ${err}`;
        }
      }
      if (errorInfo) {
        scope.setExtras(errorInfo);
      }
      Sentry.captureException(errorToReport);
    });
  }
};

export { handleApiError };
